/** An explicit service decision overrides its category, including accept-all cookies. */
export function hasServiceConsent(consent, service, category = 'external') {
    if (category === 'necessary') return true;
    const decision = consent?.services?.[service];
    if (typeof decision === 'boolean') return decision;
    return consent?.categories?.[category] === true;
}
